var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2894 0.29429L8.47156 14.1123C8.37865 14.2056 8.26825 14.2796 8.14668 14.3301C8.02511 14.3806 7.89476 14.4066 7.76312 14.4066C7.63147 14.4066 7.50113 14.3806 7.37956 14.3301C7.25798 14.2796 7.14758 14.2056 7.05468 14.1123L1.71114 8.76329C1.61824 8.67001 1.50784 8.596 1.38626 8.5455C1.26469 8.495 1.13434 8.469 1.0027 8.469C0.87106 8.469 0.740713 8.495 0.619141 8.5455C0.497569 8.596 0.387165 8.67001 0.294264 8.76329V8.76329C0.200995 8.8562 0.126989 8.96661 0.0764917 9.0882C0.0259944 9.20978 0 9.34013 0 9.47179C0 9.60344 0.0259944 9.7338 0.0764917 9.85538C0.126989 9.97697 0.200995 10.0874 0.294264 10.1803L5.6398 15.5253C6.2037 16.0882 6.96788 16.4043 7.76462 16.4043C8.56135 16.4043 9.32553 16.0882 9.88943 15.5253L23.7062 1.71029C23.7994 1.6174 23.8732 1.50705 23.9236 1.38556C23.9741 1.26407 24 1.13382 24 1.00229C24 0.870755 23.9741 0.740512 23.9236 0.619022C23.8732 0.497532 23.7994 0.387181 23.7062 0.29429C23.6133 0.201013 23.5029 0.127 23.3814 0.0764985C23.2598 0.0259969 23.1294 0 22.9978 0C22.8662 0 22.7358 0.0259969 22.6142 0.0764985C22.4927 0.127 22.3823 0.201013 22.2894 0.29429V0.29429Z",
    fill: "#67C97E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5c2d5ebeba465606be805dbd57eae7ca.svg";
export { ForwardRef as ReactComponent };